import z from 'zod';
import { EntitySchema, UserRoleEnum } from '../primitives';

export const AuthorizationSchema = EntitySchema.extend({
    email: z.string(),
    token: z.string(),
    expiresAt: z.string(),
    roles: z.array(UserRoleEnum),
});

export type Authorization = z.infer<typeof AuthorizationSchema>;
